import React from 'react';
import { Switch, BrowserRouter, Route } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/sv';

import './App.scss';
import { Header } from './components/common';
import routes from './routes';

function App() {
  moment.locale('sv');

  return (
    <div>
      <Header />
      <BrowserRouter>
        <Switch>
          {routes.map((route, index) => {
            return (
              <Route key={index} path={route.path} exact={route.exact}>
                {route.view}
              </Route>
            );
          })}
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
